import type { ToolContent } from "./tool-content";
import { getPtBrPdfToolBySlug } from "./pt-br-pdf-catalog";

interface PtBrPdfSeoOverride {
  h1Title: string;
  seoTitle: string;
  seoDescription: string;
  intro: string;
  faq?: { q: string; a: string }[];
}

const PT_BR_PDF_SEO_DATA: Record<string, PtBrPdfSeoOverride> = {
  "juntar-pdf": {
    h1Title: "Juntar PDF Grátis Online — Combinar Arquivos PDF",
    seoTitle: "Juntar PDF Grátis Online — Combinar Arquivos | Picamini.online",
    seoDescription: "Juntar PDF grátis online sem instalar programas nem enviar arquivos para servidores externos. Combine vários documentos PDF em um só de forma 100% privada.",
    intro: "Combine dois ou mais arquivos PDF em um único documento organizado online e grátis. Reordene páginas e baixe instantaneamente com total segurança.",
    faq: [
      {
        q: "É seguro juntar meus arquivos PDF no Picamini.online?",
        a: "Com certeza. O processo de junção é realizado 100% localmente no seu próprio navegador via JavaScript. Seus arquivos nunca são enviados para servidores externos."
      },
      {
        q: "Existe limite na quantidade de arquivos PDF que posso juntar?",
        a: "Não há limites artificiais. Você pode combinar quantos arquivos PDF a memória do seu dispositivo suportar."
      }
    ]
  },
  "dividir-pdf": {
    h1Title: "Dividir PDF Online Grátis — Separar Páginas de PDF",
    seoTitle: "Dividir PDF Online Grátis — Separar Páginas | Picamini.online",
    seoDescription: "Dividir PDF grátis online — extraia páginas específicas ou separe documentos PDF grandes em arquivos independentes sem fazer upload.",
    intro: "Separe páginas ou extraia intervalos personalizados em novos documentos PDF individuais de maneira simples, rápida e privada.",
  },
  "organizar-pdf": {
    h1Title: "Organizar Páginas de PDF Grátis Online",
    seoTitle: "Organizar Páginas de PDF Grátis Online | Picamini.online",
    seoDescription: "Reordene, gire ou exclua folhas dos seus arquivos PDF arrastando e soltando visualmente no seu navegador.",
    intro: "Reorganize a ordem das páginas do seu arquivo PDF de forma intuitiva sem enviar documentos para a internet.",
  },
  "girar-pdf": {
    h1Title: "Girar PDF Online Grátis — Alterar Orientação",
    seoTitle: "Girar PDF Online Grátis — Virar Páginas | Picamini.online",
    seoDescription: "Gire folhas individuais ou todas as páginas do seu arquivo PDF em 90, 180 ou 270 graus permanentemente.",
    intro: "Corrija a orientação de folhas digitalizadas de ponta-cabeça ou de lado de forma permanente.",
  },
  "extrair-paginas-pdf": {
    h1Title: "Extrair Páginas de PDF Grátis — Salvar Selecionadas",
    seoTitle: "Extrair Páginas de PDF Grátis Online | Picamini.online",
    seoDescription: "Selecione e extraia folhas específicas de um arquivo PDF pesado para criar um novo documento leve.",
    intro: "Escolha as páginas exatas que você precisa de um PDF e gere um novo documento limpo em segundos.",
  },
  "excluir-paginas-pdf": {
    h1Title: "Excluir Páginas de PDF Grátis — Remover Folhas",
    seoTitle: "Excluir Páginas de PDF Grátis Online | Picamini.online",
    seoDescription: "Remova folhas em branco, duplicadas ou desnecessárias dos seus documentos PDF direto no navegador.",
    intro: "Exclua de forma permanente qualquer página indesejada dos seus arquivos PDF com apenas um clique.",
  },
  "editar-pdf-online": {
    h1Title: "Editor de PDF Online Grátis — Texto, Assinaturas e Desenhos",
    seoTitle: "Editor de PDF Online Grátis — Modificar PDF | Picamini.online",
    seoDescription: "Editor de PDF grátis online. Adicione texto, assine documentos, desenhe, insira imagens e destaque conteúdos sem baixar programas.",
    intro: "Adicione anotações, caixas de texto, assinaturas desenhadas à mão e imagens nos seus documentos PDF com total praticidade.",
  },
  "numerar-paginas-pdf": {
    h1Title: "Numerar Páginas de PDF Grátis — Adicionar Numeração",
    seoTitle: "Numerar Páginas de PDF Grátis Online | Picamini.online",
    seoDescription: "Insira números de página automáticos no cabeçalho ou rodapé dos seus documentos PDF.",
    intro: "Adicione numeração personalizada aos seus trabalhos e relatórios na posição e formato que preferir.",
  },
  "marca-dagua-pdf": {
    h1Title: "Adicionar Marca d'Água no PDF Grátis — Texto ou Logo",
    seoTitle: "Adicionar Marca d'Água no PDF Grátis | Picamini.online",
    seoDescription: "Insira marcas d'água de texto ou imagem nos seus arquivos PDF grátis. Personalize transparência e ângulo.",
    intro: "Proteja seus documentos estampando marcas d'água com texto personalizado ou o logotipo da sua empresa sobre as páginas do PDF.",
  },
  "compactar-pdf": {
    h1Title: "Compactar PDF Grátis Online — Reduzir Tamanho sem Perder Qualidade",
    seoTitle: "Compactar PDF Grátis Online — Reduzir Tamanho | Picamini.online",
    seoDescription: "Compactar PDF online grátis — reduza o peso do seu arquivo PDF para enviar por e-mail sem perder nitidez. 100% privado no navegador.",
    intro: "Reduza o peso dos seus arquivos PDF para anexá-los facilmente por e-mail ou enviar em formulários online mantendo ótima qualidade visual.",
  },
  "converter-pdf-em-preto-e-branco": {
    h1Title: "Converter PDF em Preto e Branco Grátis — Escala de Cinza",
    seoTitle: "Converter PDF em Preto e Branco Grátis | Picamini.online",
    seoDescription: "Transforme arquivos PDF coloridos em escala de cinza para economizar tinta e custos de impressão.",
    intro: "Converta seus PDFs para preto e branco para economizar tinta da impressora sem prejudicar a leitura do texto.",
  },
  "reparar-pdf": {
    h1Title: "Reparar PDF Corrompido Grátis — Recuperar Arquivos",
    seoTitle: "Reparar PDF Corrompido Grátis Online | Picamini.online",
    seoDescription: "Recupere dados e conteúdos de arquivos PDF corrompidos ou danificados direto no navegador.",
    intro: "Repare documentos PDF defeituosos e recupere o texto e imagens sem perda de dados.",
  },
  "converter-jpg-em-pdf": {
    h1Title: "Converter Imagem em PDF Grátis — JPG, PNG e WEBP para PDF",
    seoTitle: "Converter Imagem em PDF Grátis (JPG para PDF) | Picamini.online",
    seoDescription: "Converter imagens JPG, PNG, WEBP e GIF em PDF online grátis. Junte várias fotos em um documento PDF organizado sem marca d'água.",
    intro: "Converta imagens JPG, PNG, WEBP ou GIF em um arquivo PDF organizado. Ajuste margens, orientação da folha e salve direto no seu computador.",
  },
  "converter-word-em-pdf": {
    h1Title: "Converter Word em PDF Grátis — DOCX para PDF Profissional",
    seoTitle: "Converter Word em PDF Grátis Online | Picamini.online",
    seoDescription: "Converter Word em PDF online grátis. Transforme documentos DOCX e DOC em arquivos PDF limpos e prontos para enviar.",
    intro: "Converta seus documentos do Word para o formato PDF diretamente no navegador garantindo que a formatação permaneça idêntica em qualquer tela.",
  },
  "converter-excel-em-pdf": {
    h1Title: "Converter Excel em PDF Grátis — XLSX para PDF",
    seoTitle: "Converter Excel em PDF Grátis Online | Picamini.online",
    seoDescription: "Converta planilhas de Excel em tabelas PDF perfeitamente formatadas e prontas para imprimir.",
    intro: "Transforme suas tabelas de Excel em documentos PDF claros e diagramados sem desajustes.",
  },
  "converter-powerpoint-em-pdf": {
    h1Title: "Converter PowerPoint em PDF Grátis — PPTX para PDF",
    seoTitle: "Converter PowerPoint em PDF Grátis Online | Picamini.online",
    seoDescription: "Converta apresentações de slides PPTX em documentos PDF compactos.",
    intro: "Converta seus slides do PowerPoint para PDF para enviar ou apresentar com facilidade em qualquer equipamento.",
  },
  "converter-html-em-pdf": {
    h1Title: "Converter HTML em PDF Grátis — Salvar Código ou Web em PDF",
    seoTitle: "Converter HTML em PDF Grátis Online | Picamini.online",
    seoDescription: "Converta código HTML ou conteúdos da web em um PDF limpo direto no seu navegador.",
    intro: "Transforme texto ou código HTML em um arquivo PDF formatado instantaneamente.",
  },
  "converter-texto-em-pdf": {
    h1Title: "Converter Texto (TXT) em PDF Grátis",
    seoTitle: "Converter Texto em PDF Grátis Online | Picamini.online",
    seoDescription: "Converta arquivos de texto simples (.txt) em documentos PDF bem diagramados.",
    intro: "Transforme anotações e arquivos de texto simples em PDFs profissionais.",
  },
  "converter-pdf-em-jpg": {
    h1Title: "Converter PDF em JPG Grátis — Extrair Imagens em Alta Qualidade",
    seoTitle: "Converter PDF em JPG Grátis (PDF para Imagem) | Picamini.online",
    seoDescription: "Converter PDF em JPG ou PNG online grátis. Extraia cada página do seu PDF como uma imagem em alta resolução instantaneamente.",
    intro: "Transforme cada página do seu documento PDF em arquivos de imagem JPG ou PNG em alta resolução prontos para salvar.",
  },
  "converter-pdf-em-word": {
    h1Title: "Converter PDF em Word Grátis — PDF para DOCX Editável",
    seoTitle: "Converter PDF em Word Grátis Online | Picamini.online",
    seoDescription: "Converter PDF em Word online grátis. Extraia o conteúdo dos seus PDFs em documentos editáveis do Word conservando o texto.",
    intro: "Transforme seus documentos PDF em arquivos editáveis do Microsoft Word para alterar textos ou tabelas facilmente.",
  },
  "converter-pdf-em-excel": {
    h1Title: "Converter PDF em Excel Grátis — Extrair Tabelas para XLSX",
    seoTitle: "Converter PDF em Excel Grátis Online | Picamini.online",
    seoDescription: "Extraia tabelas de dados contidas em arquivos PDF para planilhas editáveis do Excel.",
    intro: "Converta tabelas de PDF em planilhas de Excel para editar números e relatórios.",
  },
  "extrair-texto-do-pdf": {
    h1Title: "Extrair Texto do PDF Grátis — Copiar Conteúdo de PDF",
    seoTitle: "Extrair Texto do PDF Grátis Online | Picamini.online",
    seoDescription: "Extraia o texto simples dos seus arquivos PDF em um arquivo .txt leve instantaneamente.",
    intro: "Obtenha todo o texto escrito dos seus PDFs sem formatações complexas em um arquivo de texto limpo.",
  },
  "proteger-pdf-com-senha": {
    h1Title: "Proteger PDF com Senha Grátis — Criptografar Arquivos",
    seoTitle: "Proteger PDF com Senha Grátis Online | Picamini.online",
    seoDescription: "Proteger PDF com senha online grátis. Criptografe seus documentos confidenciais com segurança direto no seu dispositivo.",
    intro: "Proteja a privacidade dos seus documentos criptografando o arquivo com uma senha de abertura segura.",
  },
  "desbloquear-pdf": {
    h1Title: "Desbloquear PDF Grátis Online — Remover Senha de PDF",
    seoTitle: "Desbloquear PDF Grátis Online | Picamini.online",
    seoDescription: "Desbloquear PDF online grátis — remova senhas e restrições de edição em arquivos PDF de sua propriedade.",
    intro: "Elimine senhas de abertura ou restrições de impressão em arquivos PDF dos quais você seja o proprietário.",
  },
  "assinar-pdf-online": {
    h1Title: "Assinar PDF Online Grátis — Assinatura Digital e Manuscrita",
    seoTitle: "Assinar PDF Online Grátis | Picamini.online",
    seoDescription: "Adicione sua assinatura manuscrita ou imagem de rubrica em contratos e formulários PDF sem imprimir.",
    intro: "Assine documentos PDF desenhando sua assinatura ou enviando uma imagem diretamente pelo navegador.",
  },
  "ocr-em-pdf-reconhecimento-de-texto": {
    h1Title: "Reconhecimento de Texto OCR em PDF Grátis",
    seoTitle: "OCR em PDF Grátis Online | Picamini.online",
    seoDescription: "Reconhecimento óptico de caracteres (OCR) para tornar PDFs escaneados pesquisáveis e selecionáveis.",
    intro: "Converta documentos PDF escaneados em arquivos com texto pesquisável e selecionável via OCR.",
  }
};

export function getPtBrPdfToolContent(slug: string, fallbackName: string): ToolContent {
  const tool = getPtBrPdfToolBySlug(slug);
  const ptBrSlug = tool ? tool.slug : slug;
  const enSlug = tool ? tool.enSlug : slug;

  const override = PT_BR_PDF_SEO_DATA[ptBrSlug] || PT_BR_PDF_SEO_DATA[enSlug] || {};
  const name = fallbackName;

  return {
    seoTitle: override.seoTitle || `${name} Grátis Online | Picamini.online`,
    seoDescription: override.seoDescription || `Ferramenta PDF ${name.toLowerCase()} grátis online. Processe seus arquivos 100% privado no próprio navegador.`,
    h1Title: override.h1Title || `${name} Online Grátis — 100% no seu Navegador`,
    intro: override.intro || `Utilize nossa ferramenta de ${name.toLowerCase()} de forma rápida, privada e sem limites. Todo o processamento ocorre no seu próprio dispositivo.`,
    whatIs: [
      `A ferramenta ${name} faz parte da suíte PDF Toolkit Pro do Picamini.online, projetada para oferecer processamento de documentos ultrarrápido e seguro.`,
      `Diferente de conversores online tradicionais que enviam seus arquivos privados para servidores na nuvem, nosso sistema executa todas as operações na memória do seu próprio aparelho.`,
      `Isso garante velocidade máxima sem tempo de espera para upload e com privacidade total dos seus dados.`
    ],
    howTo: [
      "Arraste ou selecione seu arquivo PDF na área de trabalho.",
      "Ajuste as opções de acordo com sua necessidade (páginas, ordem, qualidade ou senha).",
      "Clique no botão principal para processar o documento em segundos.",
      "Baixe seu arquivo PDF resultante imediatamente para seu dispositivo."
    ],
    features: [
      "100% Grátis sem limites de arquivos nem marcas d'água",
      "Privacidade absoluta: Seus documentos nunca saem do seu computador ou celular",
      "Processamento ultrarrápido direto no navegador",
      "Compatível com qualquer sistema operacional (Windows, Mac, Linux, Android e iOS)",
      "Sem cadastros, contas ou necessidade de baixar programas"
    ],
    benefits: [
      "Conformidade total com a LGPD por não enviar dados para servidores externos",
      "Disponibilidade imediata sem filas de processamento em servidores",
      "Conserva a nitidez e a formatação dos seus arquivos originais"
    ],
    proTips: [
      "Para contratos confidenciais ou documentos pessoais, o processamento direto no navegador é a opção mais segura.",
      "Se for processar múltiplos arquivos, certifique-se de permitir downloads múltiplos no seu navegador."
    ],
    faq: override.faq || [
      {
        q: `É seguro usar o ${name}?`,
        a: "Sim, totalmente seguro. Como o processamento ocorre no seu próprio navegador, seus arquivos nunca são transmitidos pela internet."
      },
      {
        q: "Preciso me cadastrar ou pagar alguma taxa?",
        a: "Não. Todas as ferramentas do Picamini.online são 100% gratuitas e não exigem nenhum tipo de cadastro."
      }
    ]
  };
}
